import React from 'react';
import { Input } from 'semantic-ui-react';
import TipSelector from './TipSelector';

const CartDetails = ({ amounts, handleChange }) => {
  const { subtotal, taxes, tip = 0, surcharges = 0 } = amounts;

  return (
    <div className="checkout-modal-summary">
      <h5 style={{ marginBottom: '0.5rem' }}>Cart Summary</h5>
      <div>
        <div>Subtotal:</div>
        <div>${subtotal.toFixed(2)}</div>
      </div>
      <div>
        <div>Taxes:</div>
        <div> ${taxes.toFixed(2)}</div>
      </div>
      {surcharges > 0 && <div>Fee: ${surcharges.toFixed(2)}</div>}
      <div>
        <div>Tip:</div>
        <TipSelector handleChange={handleChange} tip={tip} amount={subtotal + taxes} />
        <div>${tip ? tip.toFixed(2) : 0.0}</div>
      </div>
      <Total amounts={amounts} />
    </div>
  );
};

function Total({ amounts }) {
  const { subtotal, taxes, tip = 0, surcharges = 0 } = amounts;
  const amount = subtotal + taxes + tip + surcharges;
  return (
    <div>
      <div>Total:</div>
      <div>${amount.toFixed(2)}</div>
    </div>
  );
}

export default CartDetails;
